<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <div
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Riscos
            <div class="q-pa-md q-gutter-sm">
              <q-btn
                label="Filtros"
                no-caps
                icon="filter_alt"
                color="primary"
                @click="abrirModal = true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <q-dialog
      v-model="abrirModal"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 700px">
        <div class="bg-brand-1 text-white">
          <q-card-section>
            <div class="text-h6">Selecione os Filtros</div>
          </q-card-section>
          <q-card-section class="q-pt-none">
            Depois de selecionado, click em 'ok' para carregar os dados.
          </q-card-section>
        </div>

        <div
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div class="col">
            <div class="text-brand-5 text-weight-bold">Status</div>
            <q-select
              dense
              outlined
              v-model="statusSelecionado"
              option-label="label"
              option-value="value"
              map-options
              emit-value
              :options="opcoesStatus"
            />
          </div>
        </div>

        <q-card-actions align="right" class="q-px-sm q-pb-sm">
          <q-btn
            label="Filtrar"
            no-caps
            icon="filter_alt"
            :loading="!!loadingValue"
            color="primary"
            @click="gerarRelatorio"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Relatorio_Riscos'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      @flexmonsterLoading="loadingStop"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Flexmonster from "../../relatorios/components/Flexmonster.vue";

export default {
  components: { Flexmonster },
  setup() {
    const store = useStore();
    const route = useRoute();

    const abrirModal = ref(true);
    const link = ref("");
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      Id_Risco: { type: "string" },
      Matricula_Usuario_Criador: { type: "string" },
      Matricula_Usuario_Exclusão: { type: "string" },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const filtrosObject = ref(null);
    const showTotals = ref("");
    const showGrandTotals = ref("");
    const formats = ref([]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});

    const statusSelecionado = ref(null);
    const opcoesStatus = [
      { label: "Todos", value: null },
      { label: "Ativos", value: 1 },
      { label: "Inativos", value: 0 },
    ];

    const slice = ref({
      columns: "",
      rows: [{ uniqueName: "ProviderName" }],
      reportFilters: "",
      measures: [
        { uniqueName: "Id_Risco" },
        { uniqueName: "Codigo_Risco" },
        { uniqueName: "Nome_Risco" },
        { uniqueName: "Data_Criação_Risco" },
        { uniqueName: "Data_Atualização_Risco" },
        { uniqueName: "Data_Exclusão_Risco" },
        { uniqueName: "Nome_Usuario_Criador" },
        { uniqueName: "Matricula_Usuario_Criador" },
        { uniqueName: "Perfil_Usuario_Criador" },
        { uniqueName: "Nome_Usuario_Exclusão" },
        { uniqueName: "Matricula_Usuario_Exclusão" },
        { uniqueName: "Perfil_Usuario_Exclusão" },
      ],
    });

    const loadingStop = () => {
      loadingValue.value = false;
    };

    const gerarRelatorio = async () => {
      try {
        filtrosObject.value = {
          status: statusSelecionado.value ?? undefined,
        };
        loadingValue.value = true;

        const response = await store.dispatch(
          "gestaoDeRiscos/relatorioRiscos",
          filtrosObject.value
        );

        link.value = response.data.return?.url || response.data.result?.url;
        updateLink.value++;
        filtros.value = JSON.stringify(filtrosObject);
        url.value = response?.request?.responseURL;
        exibir.value = true;
        abrirModal.value = false;
        loadingValue.value = false;
      } catch {
        loadingValue.value = false;
      }
    };

    const id = route.params.id;
    onMounted(() => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        store
          .dispatch("rel/listarRelatoriosSalvos", { id })
          .then((response) => {
            let value = response.data.resultado.dados.map((e) => {
              e.template = JSON.parse(e.template);
              return e;
            });
            dados.value = value[0];
            urlEp.value = dados.value.url;
            url.value = dados.value.url;
            gerarCsv.value = true;
            abrirModal.value = false;
          })
          .catch(() => {});
      }
    });

    return {
      abrirModal,
      link,
      layout,
      loadingValue,
      types,
      updateLink,
      exibir,
      filtros,
      showTotals,
      showGrandTotals,
      formats,
      url,
      gerarCsv,
      urlEp,
      dados,
      slice,
      statusSelecionado,
      opcoesStatus,
      loadingStop,
      gerarRelatorio,
    };
  },
};
</script>
